var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"def-container"},[_c('div',{staticClass:"label-text"},[_vm._v(_vm._s(_vm.property.abbreviation ? _vm.property.abbreviation : _vm.property.name)+":")]),_c('div',{staticClass:"def-value"},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }